import React, { useEffect, useState } from 'react';

import PagePanel from 'src/components/PagePanel';
import PageHeader from 'src/components/PageHeader';
import { useAdminPermissions } from 'src/hooks/useAdminPermissions';
import { PERMISSIONS } from 'src/utils/permissions';
import { useResetPageParam } from 'src/hooks/useResetPageParam';

import ActivityTab from './ActivityTab';
import ThirdPartyTab from './ThirdPartyTab';
import { LogTab, LogTabs, RestrictedNote } from './styled';

type LogsView = 'activity' | 'third-party';

const Logs = () => {
  const { can } = useAdminPermissions();
  const canActivity = can(PERMISSIONS.ALL);
  const canThirdParty = can(PERMISSIONS.DASHBOARD_READ);

  const [activeTab, setActiveTab] = useState<LogsView>(canActivity ? 'activity' : 'third-party');
  const resetPageParam = useResetPageParam();
  const [totalCount, setTotalCount] = useState<number | null>(null);

  useEffect(() => {
    if (activeTab === 'activity' && !canActivity && canThirdParty) {
      setActiveTab('third-party');
    }
  }, [activeTab, canActivity, canThirdParty]);

  const title = totalCount == null ? 'Logs' : `Logs (${totalCount})`;

  return (
    <PagePanel>
      <PageHeader title={title} hideSearch />
      <LogTabs>
        {canActivity && (
          <LogTab
            type="button"
            $active={activeTab === 'activity'}
            onClick={() => {
              setActiveTab('activity');
              setTotalCount(null);
              resetPageParam();
            }}
          >
            Activity
          </LogTab>
        )}
        {canThirdParty && (
          <LogTab
            type="button"
            $active={activeTab === 'third-party'}
            onClick={() => {
              setActiveTab('third-party');
              setTotalCount(null);
              resetPageParam();
            }}
          >
            Third-party
          </LogTab>
        )}
      </LogTabs>

      {activeTab === 'activity' && canActivity && <ActivityTab onTotalChange={setTotalCount} />}
      {activeTab === 'third-party' && canThirdParty && (
        <ThirdPartyTab onTotalChange={setTotalCount} />
      )}

      {!canActivity && !canThirdParty && (
        <RestrictedNote>You do not have permission to view logs.</RestrictedNote>
      )}
    </PagePanel>
  );
};

export default Logs;
